var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message__gift"},[_c('img',{staticClass:"message__image",attrs:{"src":`${_vm.s3UrlStatic}/${_vm.message.src}`,"alt":"gift","width":"130","height":"130"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }